/**
 * Get the value of a CSS variable in pixels.
 * @param variableName - The name of the CSS variable (e.g., '--my-var').
 * @returns The value of the CSS variable in pixels if the value uses 'rem' or 'px' units; returns 0 for unsupported units (such as %, em, vw, etc.) or if the variable is not set.
 */
export function getCSSVariableValue(variableName: string): number {
  if (globalThis.window === undefined || typeof document === 'undefined') {
    return 0;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();

  // Convert rem/px to pixels
  if (value.endsWith('rem')) {
    const remValue = parseFloat(value);
    const rootFontSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize,
    );
    if (isNaN(remValue) || isNaN(rootFontSize)) {
      return 0;
    }
    return remValue * rootFontSize;
  } else if (value.endsWith('px')) {
    const pxValue = parseFloat(value);
    return isNaN(pxValue) ? 0 : pxValue;
  }

  return 0;
}
